import { render, staticRenderFns } from "./TuyunDownload.vue?vue&type=template&id=1d7e35c2&"
import script from "./TuyunDownload.vue?vue&type=script&lang=js&"
export * from "./TuyunDownload.vue?vue&type=script&lang=js&"
import style0 from "./TuyunDownload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports